/**
 * Popup Maker's open() sequence queues a delayed opacity:0 reset on the
 * overlay before it runs the chosen open animation. For popups with the
 * overlay disabled (e.g. the "Top Bar" display preset), that reset lands
 * in jQuery's fx queue behind an already-pending item and fires *after*
 * the animation finishes, silently re-hiding the popup on every open.
 * This forces the overlay back to visible once Popup Maker itself
 * considers the popup open.
 */
if ( window.jQuery ) {
	window.jQuery( document ).on( 'pumAfterOpen', '.pum-overlay-disabled', function() {
		window.jQuery( this ).stop( true, true ).css( 'opacity', 1 );
	});
}
